---
title: Regulamin
updated: 2026-10-02
---

## 1. Akceptacja Warunków

Tworząc konto lub korzystając z Draughts Game („Usługa"), akceptujesz niniejsze Warunki Korzystania z Usługi. Jeśli się z nimi nie zgadzasz, prosimy nie korzystać z Usługi.

## 2. Opis Usługi

Draughts Game to platforma internetowa do gry w warcaby w wielu wariantach. Usługa obejmuje dobieranie przeciwników (innych graczy lub komputera), turnieje, rankingi graczy, zadania taktyczne oraz funkcje analizy partii.

## 3. Rejestracja Konta

Aby uzyskać dostęp do niektórych funkcji, musisz utworzyć konto, podając nazwę użytkownika, adres e-mail i hasło. Przed zalogowaniem musisz zweryfikować swój adres e-mail. Odpowiadasz za zachowanie poufności swoich danych logowania. Możesz też grać jako gość bez rejestracji, z ograniczoną funkcjonalnością.

- Aby utworzyć konto, musisz mieć ukończone 16 lat.
- Możesz utworzyć tylko jedno konto na osobę.
- Odpowiadasz za całą aktywność prowadzoną z Twojego konta.

## 4. Zasady Postępowania

Korzystając z Usługi, zobowiązujesz się nie:

- Korzystać z zewnętrznej pomocy (silników, solverów) podczas partii rankingowych.
- Celowo przegrywać partii w celu manipulowania rankingiem (sandbagging).
- Zmawiać się z innymi graczami w turniejach.
- Nękać, grozić ani obrażać innych użytkowników.
- Tworzyć wielu kont w celu obejścia banów lub manipulowania rankingami.
- Próbować wykorzystywać błędy lub luki w zabezpieczeniach platformy.
- Używać zautomatyzowanych narzędzi (botów) do gry bez zezwolenia.

## 5. Fair Play

Zastrzegamy sobie prawo do stosowania zautomatyzowanych systemów wykrywających oszustwa i nieuczciwą grę. Naruszenia mogą skutkować ostrzeżeniami, tymczasowymi zawieszeniami, korektami rankingu lub trwałymi banami, według naszego uznania.

## 6. Własność Intelektualna

Usługa, w tym jej wygląd, oryginalny kod, grafika i treści, jest własnością Draughts Game. Zapisy partii (ruchy, wyniki) są danymi publicznymi i mogą być swobodnie udostępniane. Treści tworzone przez użytkowników (nazwy użytkowników, wiadomości czatu) pozostają własnością ich autorów.

## 7. Dostępność i Zmiany

Staramy się, aby Usługa była dostępna przez cały czas, ale nie gwarantujemy nieprzerwanego dostępu. Zastrzegamy sobie prawo do modyfikowania, zawieszania lub zakończenia dowolnej części Usługi w dowolnym momencie. Możemy od czasu do czasu aktualizować niniejsze Warunki. Dalsze korzystanie z Usługi po zmianach oznacza ich akceptację.

## 8. Ograniczenie Odpowiedzialności

Usługa jest świadczona „tak jak jest", bez jakichkolwiek gwarancji, wyraźnych lub dorozumianych. Nie ponosimy odpowiedzialności za szkody pośrednie, przypadkowe ani następcze wynikające z korzystania z Usługi. Nasza łączna odpowiedzialność nie przekroczy kwoty, jaką nam zapłaciłeś w ciągu 12 miesięcy poprzedzających roszczenie (jeśli dotyczy).

## 9. Rozwiązanie Umowy

Możesz usunąć swoje konto w dowolnym momencie w ustawieniach profilu („Usuń konto") lub kontaktując się z nami. Możemy zamknąć lub zawiesić Twoje konto, jeśli naruszysz niniejsze Warunki lub będziesz działać na szkodę Usługi lub innych użytkowników.

## 10. Kontakt

W przypadku pytań dotyczących niniejszych Warunków skontaktuj się z nami pod adresem: [legal@draughtsgame.com](mailto:legal@draughtsgame.com)
